module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Permissões")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v("Os Executivos de Vendas/SDR podem criar ou editar templates no Reev?")]), _c('div', {
    staticClass: "toggler-inline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSellerCanEditTemplates()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.seller_can_edit_templates
    }
  }), _c('label', [_vm._v(_vm._s(_vm.seller_can_edit_templates ? "Sim" : "Não"))])])]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v("Os Executivos de Vendas/SDR podem visualizar todos os contatos da base do Reev?")]), _c('div', {
    staticClass: "toggler-inline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSellerCanSeeAllContacts()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.seller_can_see_all_contacts
    }
  }), _c('label', [_vm._v(_vm._s(_vm.seller_can_see_all_contacts ? "Sim" : "Não"))])])]), _c('hr'), _c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v("Os Executivos de Vendas/SDRs podem alterar a responsabilidade de contatos para si mesmos?")]), _c('div', {
    staticClass: "toggler-inline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleSellerCanChangeResponsability()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.seller_can_change_responsability
    }
  }), _c('label', [_vm._v(_vm._s(_vm.seller_can_change_responsability ? "Sim" : "Não"))])])]), _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Salvar")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-568a48e2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/permissions.vue
// module id = 1127
// module chunks = 1